// extracted by mini-css-extract-plugin
export var section = "section-module--section--iFVFn";
export var section__content = "section-module--section__content---ohZk";
export var section__title = "section-module--section__title--GiXFP";
export var section__desc = "section-module--section__desc--Kswbg";